import { createFileRoute } from '@tanstack/react-router'

import { TeamPage } from '@/pages/team/Team.page'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/team/',
)({
  component: TeamPage,
  loader: () => ({ breadcrumbTitle: 'Team' }),
})
